import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";

import { AxiosCustomGet } from "../axios/AxiosCustom";
import Config from "../axios/Config";
import { getUserAuthorizations } from "../template/authorization/Authorization";
import { ContextProvider } from "../template/authorization/MyContext";

export const PermissionContext = React.createContext({});

const Permission = ({ children }) => {
  const [myPermissions, setMyPermissions] = useState({});
  const [userAuthorizations, setUserAuthorizations] = useState({});

  // const getMyPermissions = () => {
  //   const url = `${process.env.REACT_APP_BASE_API_URL}permissions/myPermissions`;

  //   AxiosCustomGet(
  //     url,
  //     Config({
  //       Authorization: `Bearer ${Cookies.get("access_token")}`,
  //     }),
  //     (response) => {
  //       setMyPermissions(response.data.data);
  //     }
  //   );
  // }

  const getUserAuthorization = async () => {
    let user_authorizations = await getUserAuthorizations();
    setUserAuthorizations(user_authorizations);
  };

  useEffect(() => {
    getUserAuthorization();
    // getMyPermissions();
  }, []);

  return (
    <ContextProvider
      value={{
        user_authorizations: userAuthorizations,
      }}
    >
      {children}
    </ContextProvider>
  );
};

export default Permission;
